import { Spinner } from "../modules/spinner";
import { PrognosisGraph } from "../partials/prognosisGraph";

declare var $: any;

export class Prognosis {

    private static saveReportButtonClass = ".js-save-report-btn";
    private static prognosisReplaceClass = ".js-prognosis-replace";
    private static graphContainerClass = ".js-prognosis-graph";

    static init() {
        $(".prognosis").on("click", ".js-add-prognosis", Prognosis.addNew);
        $(".prognosis").on("click", ".js-remove-prognosis", Prognosis.delete);
        $(".prognosis").on("click", ".js-show-prognosis", Prognosis.show);
        $(".prognosis").on("foldout", Prognosis.saveGraphState);
        Prognosis.initSaveReportButton();
    }

    static initSaveReportButton() {
        $(".prognosis").on("click", ".js-save-prognosis-btn", Prognosis.savePrognosis);
        $(".prognosis").on("click", ".js-generate-report-btn", Prognosis.generateReport);
        $(Prognosis.saveReportButtonClass).on("click", Prognosis.saveReport);
    }

    static saveReport(e: Event) {
        e.preventDefault();
        const $button = $(Prognosis.saveReportButtonClass);

        if ($button.is("[disabled=disabled]")) {
            return;
        }

        const url = $button.attr("href");
        const type = "post";

        Spinner.spin($button);

        $.ajax({
            type: type,
            url: url,
            success(responseData: any) {
                Spinner.stop($button, false, "Rapport sparad");
            },
            error(responseData: any) {
                Spinner.stop($button);
            }
        });
    }

    static savePrognosis(event: Event) {
        event.preventDefault();
        const $form = $(".prognosis form");
        const uri = $form.attr("action");
        const formData = $form.serialize();
        Prognosis.callServer(uri, "PUT", $form, formData);
    }

    static generateReport(event: Event) {
        event.preventDefault();
        const $button = $(event.target).closest("button");
        const uri = $button.data("uri");
        const projectState = $button.data("project-state");
        const $form = $(".prognosis form");
        const formData = $form.serialize();
        Spinner.spin($button);

        $.ajax({
            type: "post",
            url: uri,
            data: formData,
            success(responseData: any) {
                Spinner.stop($button, false, responseData);
            },
            error(responseData: any) {
                Spinner.stop($button);
            }
        });
    }

    static addNew(event: Event) {
        const button = $(event.target).closest("button");
        const uri = button.data("uri");
        Prognosis.callServer(uri, "POST", $(button));
    }

    static show(event: Event) {
        event.preventDefault();
        const $anchor = $(this);
        const uri = $anchor.attr("href");
        const $li = $anchor.closest("li");
        Prognosis.callServer(uri, "GET", $li);
    }

    static delete(event: Event) {
        const button = $(event.target).closest("button");
        const uri = button.data("uri");
        Prognosis.callServer(uri, "DELETE", $(button));
    }

    static saveGraphState() {
        const value = $(".foldout").hasClass("foldout--open") ? "1" : "0";
        $("input[name=graphState]").val(value);
    }

    static loadGraphState() {
        const value = $("input[name=graphState]").val();
        if (value === "1") {
            $(".foldout").addClass("foldout--open");
            $("div.foldout-blind", $(this)).show();
        }
    }

    private static callServer(uri: string, verb: string, spinner: any = null, formData?: string) {
        if (spinner)
            Spinner.spin(spinner);

        $.ajax({
            type: verb,
            url: uri,
            data: formData ? formData : null,
            success(responseData: any) {
                $(Prognosis.prognosisReplaceClass).html(responseData.ViewString);
                Prognosis.initSaveReportButton();
                $(Prognosis.prognosisReplaceClass).trigger("graphReloaded", [responseData.PrognosisGraph]);
                Prognosis.loadGraphState();
            },
            complete() {
                if (spinner)
                    Spinner.stop(spinner);
            }
        });
    }

}



// WEBPACK FOOTER //
// ./assets/scripts/partials/prognosis.ts